/**
 * @fileoverview GET handler for the "/dashboard/async_request_manager/find_request" endpoint
 */
import fetch from "@lib/fetch";

import type { Request } from "../dashboardAsyncRequestManagerListRequests/types";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { dashboardAsyncRequestManagerFindRequest } from "./constants";
import { isAsyncRequestManagerFindRequestResult } from "./validators";

export const getAsyncRequestManagerFindRequest = reactQueryFetcherAdapter(
  dashboardAsyncRequestManagerFindRequest,
  (signal: AbortSignal, useCase: string, metadataKey: string, metadataValue: string): Promise<Request> => {
    return fetch(
      "/dashboard/async_request_manager/find_request",
      "GET",
      { use_case: useCase, metadata_key: metadataKey, metadata_value: metadataValue },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isAsyncRequestManagerFindRequestResult
);
